import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { FullLayoutComponent } from "./layouts/full/full-layout.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";

import { Full_ROUTES ,Full_ROUTES_FOR_ADMIN_Role,Full_ROUTES_FOR_ADMIN_AND_MODERATOR_Role} from "./shared/routes/full-layout.routes";
import { CONTENT_ROUTES } from "./shared/routes/content-layout.routes";

import { AuthGuard } from './shared/auth/auth-guard.service';
import { AdminAuthGuard } from './shared/auth/admin.auth.guard.service';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'pages/login',
    pathMatch: 'full',
  },
  { path: '', component: FullLayoutComponent, data: { title: 'Only Admin and modrator',role:["admin","moderator"] }, children: Full_ROUTES_FOR_ADMIN_AND_MODERATOR_Role, canActivate: [AuthGuard] },
  { path: '', component: FullLayoutComponent, data: { title: 'Only Admin',role:["admin"] }, children: Full_ROUTES_FOR_ADMIN_Role, canActivate: [AuthGuard] },
  { path: '', component: FullLayoutComponent, data: { title: 'full Views' }, children: Full_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: ContentLayoutComponent, data: { title: 'content Views' }, children: CONTENT_ROUTES },
  {
    path: '**',
    redirectTo: 'pages/error'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy', useHash: true })],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
